import React, { useEffect, useRef } from 'react'
import { SearchBig, Truckbody, Tires, Road, AddwithWhiteCircle, UpdatePencil, DeleteDustbin } from "../AllSvg";
import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { handleErrorToast } from '../custom';
import { toast, ToastContainer } from 'react-toastify';
import { Modal } from 'react-bootstrap';


const AddNotes = ({ getNotes, worktypeName }) => {
    const [formData, setFormData] = useState({
        worktype_id: "null",
        data: [{
            description: "",
        }]
    });


    console.log("formdata console")
    console.log(formData)


    const [isSubmitted, setIsSubmitted] = useState(false);

    const [show, setShow] = useState(false);

    const handleShow = () => {

        setShow(true);
        getCompany();
    }

    const handleClose = () => {
        setShow(false);

        setFormData({
            worktype: "null",
            data: [{
                description: "",
            }]
        })
        setErrors({});
    }

    const addNewDescription = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            data: [...prevFormData.data, { description: "" }],
        }));
    };


    const handleDescriptionChange = (index, value) => {
        const updatedData = [...formData.data];
        updatedData[index].description = value;
        setFormData({ ...formData, data: updatedData });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[`description_${index}`];
                return updatedErrors;
            });
        }
    };
    const fileInputRefs = useRef([]);

    const handleRemoveData = (index) => {
        setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
        fileInputRefs.current.splice(index, 1);
    };


    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};


        const requiredFields = ["worktype_id"];
        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field] === "null") {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });


        formData.data.forEach((item, index) => {
            if (!item.description.trim()) {
                newErrors[`description_${index}`] = `This is required field!`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };



    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {

            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                let res = await axios.post(`${BASE_URL}/project/note/`, formData)

                if (res.status === 200 || res.status === 200) {
                    getNotes();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Client Name Added successfully!");

                } else {
                    alert(res);
                }
            } catch (err) {

                if (err.response) {
                    toast.dismiss(loadingToastId);
                    const errorData = err.response.data;

                    if (typeof errorData.error === 'string') {

                        toast.error(`Error: ${errorData.error}`);
                    } else if (typeof errorData === 'object' && errorData !== null) {

                        Object.entries(errorData).forEach(([field, messages]) => {
                            messages.forEach(message => toast.error(`"${field}": ${message}`));
                        });
                    } else {
                        toast.error('Error:- Failed to Process!');
                    }
                } else {
                    toast.error('Error processing your request.');
                }
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }

        }
    };
    const [company, setCompany] = useState([]);

    const getCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/project/subcompany/`);
            setCompany(res.data);
        } catch (error) {
            console.error(error);

        }
    }




    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value,
        });

        setFormData({
            ...formData,
            [name]: value,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };


    const removeDescription = (index) => {
        const updatedData = formData.data.filter((_, i) => i !== index);
        setFormData({ ...formData, data: updatedData });


        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[`description_${index}`];


            const reorderedErrors = {};
            Object.keys(updatedErrors).forEach((key) => {
                if (key.startsWith("description_")) {
                    const idx = parseInt(key.split("_")[1], 10);
                    reorderedErrors[
                        `description_${idx > index ? idx - 1 : idx}`
                    ] = updatedErrors[key];
                } else {
                    reorderedErrors[key] = updatedErrors[key];
                }
            });

            return reorderedErrors;
        });
    };


    return (
        <>
            <button className='upload-svg' onClick={handleShow}>
                <AddwithWhiteCircle /> {"Notes"}
            </button>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
                <Modal.Header closeButton>
                    <Modal.Title>Add Notes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">

                        <div className='flex-column' style={{ justifyContent: "space-between" }}>
                            <div className='flex-row justify-between'>

                                <div className="flex-column form-group-select">
                                    <label className="form-labels">Select Work Type:
                                    </label>
                                    <select
                                        name="worktype_id"
                                        value={formData.worktype_id}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.worktype_id ? 'error' : inputState.worktype_id ? 'success' : ''}`}
                                    >
                                        <option value="null" >Select Work Type</option>
                                        {Array.isArray(worktypeName) && worktypeName.map(item => (

                                            <option key={item.id} value={item.id}>
                                                {item.title}
                                            </option>
                                        ))}

                                    </select>

                                    {errors.worktype_id && (
                                        <span className="error-message">{errors.worktype_id}</span>
                                    )}

                                </div>
                                {/* <div className="bdy-div flex-cont justify-around"> */}
                                <div className="flex-column ">
                                    <button className='upload-svg' onClick={addNewDescription}>
                                        <AddwithWhiteCircle /> Add More Description
                                    </button>
                                </div>


                            </div>
                            <table className="nested-table-lightblue width-90vw payment border-table">
                                <thead className='border-table'>
                                    <tr>
                                        <th className='text-center' style={{ width: "5%" }}>S.No.</th>
                                        <th className='text-center'>Description</th>
                                        <th style={{ width: "5%" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.data?.map((item, index) => (
                                        <tr key={index} style={{ border: "none" }}>
                                            <td className='font-weight600 text-center'>{index + 1}.</td>
                                            <td className='notes-description'>
                                                <textarea
                                                    rows="3"
                                                    placeholder={`Enter description ${index + 1}`}
                                                    value={item.description}
                                                    onChange={(e) =>
                                                        handleDescriptionChange(index, e.target.value)
                                                    }
                                                    className="form-input-textarea"
                                                    style={{ width: "90%", marginLeft: "4%" }}
                                                />
                                                {errors[`description_${index}`] && (
                                                    <div className="error-message text-center">{errors[`description_${index}`]}</div>
                                                )}
                                            </td>
                                            <td className='text-center'>
                                                {formData.data.length > 1 &&
                                                    <button
                                                        type="button"
                                                        onClick={() => removeDescription(index)}
                                                        className="remove-btn"
                                                    >
                                                        ❌
                                                    </button>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>



                            {/* </div> */}




                        </div>
                    </div>
                </Modal.Body>
                <div className="button-models-gap-116 " >
                    <div className="">
                        <button type="button" onClick={handleClose} className="model-button-cancel model-button   font-weight500  ">Cancel</button>
                    </div>

                    <div className="">
                        <button onClick={handleSubmit} type='submit' className="model-button model-button-submit">Submit</button>
                    </div>

                </div>

                <p className="error-message font-size-text margin-top40px">
                    {isSubmitted && Object.keys(errors).length > 0 && (
                        Object.keys(errors).length > 3 ? (
                            <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
                        ) : (
                            Object.keys(errors).map((field) =>
                                field.charAt(0).toUpperCase() + field.slice(1)
                            ).join(', ') + ' are required!'
                        )
                    )}
                </p>
            </Modal>
        </>
    );
};

const UpdateNotes = ({ getNotes, worktypeName, i }) => {
    const [formData, setFormData] = useState({
        worktype_id: "null",
        data: [{
            description: "",
        }]
    });


    console.log("formdata console")
    console.log(formData)


    const [isSubmitted, setIsSubmitted] = useState(false);

    const [show, setShow] = useState(false);

    const handleShow = () => {

        setShow(true);
        setFormData(i);
    }

    const handleClose = () => {
        setShow(false);

        setFormData({
            worktype: "null",
            data: [{
                description: "",
            }]
        })
        setErrors({});
    }

    const addNewDescription = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            data: [...prevFormData.data, { description: "" }],
        }));
    };

    const handleDescriptionChange = (index, value) => {
        const updatedData = [...formData.data];
        updatedData[index].description = value;
        setFormData({ ...formData, data: updatedData });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[`description_${index}`];
                return updatedErrors;
            });
        }
    };
    const fileInputRefs = useRef([]);



    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [];
        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field] === "null") {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        formData.data.forEach((item, index) => {
            if (!item.description.trim()) {
                newErrors[`description_${index}`] = `This is required field!`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };



    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {

            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                let res = await axios.put(`${BASE_URL}/project/note/${i.id}/`, formData)

                if (res.status === 200 || res.status === 200) {
                    getNotes();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Notes Data Updated successfully!");

                } else {
                    alert(res);
                }
            } catch (err) {

                if (err.response) {
                    toast.dismiss(loadingToastId);
                    const errorData = err.response.data;

                    if (typeof errorData.error === 'string') {

                        toast.error(`Error: ${errorData.error}`);
                    } else if (typeof errorData === 'object' && errorData !== null) {

                        Object.entries(errorData).forEach(([field, messages]) => {
                            messages.forEach(message => toast.error(`"${field}": ${message}`));
                        });
                    } else {
                        toast.error('Error:- Failed to Process!');
                    }
                } else {
                    toast.error('Error processing your request.');
                }
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }

        }
    };




    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value,
        });

        setFormData({
            ...formData,
            [name]: value,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };


    const removeDescription = (index) => {
        const updatedData = formData.data.filter((_, i) => i !== index);
        setFormData({ ...formData, data: updatedData });


        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[`description_${index}`];


            const reorderedErrors = {};
            Object.keys(updatedErrors).forEach((key) => {
                if (key.startsWith("description_")) {
                    const idx = parseInt(key.split("_")[1], 10);
                    reorderedErrors[
                        `description_${idx > index ? idx - 1 : idx}`
                    ] = updatedErrors[key];
                } else {
                    reorderedErrors[key] = updatedErrors[key];
                }
            });

            return reorderedErrors;
        });
    };


    return (
        <>
            <button className='model-edit-button' onClick={handleShow}>
                <UpdatePencil />
            </button>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
                <Modal.Header closeButton>
                    <Modal.Title>Update Notes Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">

                        <div className='flex-column' style={{ justifyContent: "space-between" }}>
                            <div className='flex-row justify-between'>

                                <div className="flex-column form-group-select">
                                    <label className="form-labels">Select Work Type <span className='required'>(Read-Only)</span>
                                    </label>
                                    <input
                                        name="worktype_id"
                                        value={i?.worktype?.title}
                                        disabled
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.worktype_id ? 'error' : inputState.worktype_id ? 'success' : ''}`}
                                    />


                                </div>
                                {/* <div className="bdy-div flex-cont justify-around"> */}
                                <div className="flex-column ">
                                    <button className='upload-svg' onClick={addNewDescription}>
                                        <AddwithWhiteCircle /> Add More Description
                                    </button>
                                </div>


                            </div>
                            <table className="nested-table-lightblue width-90vw payment border-table">
                                <thead className='border-table'>
                                    <tr>
                                        <th className='text-center' style={{ width: "5%" }}>S.No.</th>
                                        <th className='text-center'>Description</th>
                                        <th style={{ width: "5%" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.data?.map((item, index) => (
                                        <tr key={index} style={{ border: "none" }}>
                                            <td className='font-weight600 text-center'>{index + 1}.</td>
                                            <td className='notes-description'>
                                                <textarea
                                                    rows="3"
                                                    placeholder={`Enter description ${index + 1}`}
                                                    value={item.description}
                                                    onChange={(e) =>
                                                        handleDescriptionChange(index, e.target.value)
                                                    }
                                                    className="form-input-textarea"
                                                    style={{ width: "90%", marginLeft: "4%" }}
                                                />
                                                {errors[`description_${index}`] && (
                                                    <div className="error-message text-center">{errors[`description_${index}`]}</div>
                                                )}
                                            </td>
                                            <td className='text-center'>
                                                {formData.data.length > 1 &&
                                                    <button
                                                        type="button"
                                                        onClick={() => removeDescription(index)}
                                                        className="remove-btn"
                                                    >
                                                        ❌
                                                    </button>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>



                            {/* </div> */}




                        </div>
                    </div>
                </Modal.Body>
                <div className="button-models-gap-116 " >
                    <div className="">
                        <button type="button" onClick={handleClose} className="model-button-cancel model-button   font-weight500  ">Cancel</button>
                    </div>

                    <div className="">
                        <button onClick={handleSubmit} type='submit' className="model-button model-button-submit">Update</button>
                    </div>

                </div>

                <p className="error-message font-size-text margin-top40px">
                    {isSubmitted && Object.keys(errors).length > 0 && (
                        Object.keys(errors).length > 3 ? (
                            <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
                        ) : (
                            Object.keys(errors).map((field) =>
                                field.charAt(0).toUpperCase() + field.slice(1)
                            ).join(', ') + ' are required!'
                        )
                    )}
                </p>
            </Modal>
        </>
    );
};
const DeleteNotes = ({ i, getData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/project/note/${i.id}/`
            );

            if (res.status === 200) {
                await getData();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete WorkType"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Notes Data of WorkType  "{i?.worktype?.title}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete?
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const Notes = ({ worktypeName, notesData, getData, buffer }) => {


    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div >
                <div className="attendance-box">
                    <div className="datagrid-container">
                        <div className="custom-table-background" style={{ height: "66vh" }}>
                            <div className="">
                                <div className="">
                                    <div className="table-box ">
                                        <div className="flex-row table-heading" style={{ justifyContent: "end" }}>
                                            <div className="table-searchh">


                                            </div>
                                            {/* <WorktypeCU getData={getnotes} usedFor="Add" /> */}
                                            <AddNotes worktypeName={worktypeName} getNotes={getData} />
                                        </div>
                                    </div>
                                    <div className='table-box scroll-container-table'
                                    >
                                        <table className="table-css width-100vw">
                                            <thead className="table-heading">
                                                <tr className="custom-table-head-tr">
                                                    <th className="table-heading ">S.no.</th>
                                                    <th className="table-heading text-left">Company Name</th>
                                                    <th className="table-heading text-left">WorkType Name</th>
                                                    <th className="table-heading text-left" style={{ paddingLeft: "10px" }}>Descriptions</th>
                                                    <th className="table-heading text-center">Action</th>
                                                </tr>
                                            </thead>
                                            {buffer ? (

                                                <div className="spinner-bgdatil"></div>

                                            ) :
                                                <tbody>
                                                    {
                                                        notesData

                                                            .map((i, index) => (
                                                                <tr key={index} className="custom-table-head-td">
                                                                    <td className="table-body ">{index + 1}.</td>
                                                                    <td className="table-body text-left">{i.worktype?.company?.title}</td>
                                                                    <td className="table-body text-left">{i.worktype?.title}</td>
                                                                    <td className="table-body justify-left ">
                                                                        <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginLeft: "20px" }}>
                                                                            {i.data.map((item, index) => (
                                                                                <li key={index} style={{ listStyleType: "inherit" }}>
                                                                                    {item.description}
                                                                                </li>
                                                                            ))}
                                                                        </ul>



                                                                    </td>
                                                                    <td>
                                                                        <div className='flex-row justify-centyer'>
                                                                            <UpdateNotes i={i} getNotes={getData} worktypeName={worktypeName} />
                                                                            <DeleteNotes i={i} getData={getData} />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                            }
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Notes; 
